export default __webpack_public_path__ + "static/media/abbeville2.ff6bc0b6.jpg";